var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[(_vm.error)?_c('Error'):_vm._e(),_c('div',{staticClass:"wrap"},[_c('div',{staticClass:"header"},[_c('router-link',{attrs:{"to":"/","exact":""}},[_vm._v("BB")]),_c('router-link',{attrs:{"to":"/about"}},[_vm._v("??")])],1),_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }